module.exports = __webpack_public_path__ + "static/media/ic_作业.6aefc334.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_作业.svg
// module id = 203
// module chunks = 0